import React from 'react';

import { Box, Tab, Tabs as MuiTabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SideBarTabs = ({
  tabs,
  selectedTab,
  selectTab,
}: {
  tabs: string[];
  selectedTab: number;
  selectTab: (tabIndex: number) => void;
}) => {
  const theme = useTheme();
  const handleChange = (newValue: number) => {
    selectTab(newValue);
  };
  return (
    <Box sx={{ backgroundColor: '#F2F2F2', padding: 1, borderRadius: 1 }}>
      <MuiTabs
        orientation="vertical"
        value={selectedTab}
        onChange={(_event, newValue) => handleChange(newValue)}
        aria-label="tabs"
        data-testid="sideBarTabs"
        sx={{
          backgroundColor: '#F2F2F2',
          '& .MuiTabs-indicator': {
            display: 'flex',
            backgroundColor: 'transparent',
          },
        }}>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab}
            sx={{
              fontWeight: 600,
              fontSize: '14px',
              transition: 'background 0.2s, color 0.2s',
              alignItems: 'start',
              textTransform: 'none',
              '&.Mui-selected': {
                color: '#9E9E9E',
                backgroundColor: theme.palette.background.paper,
              },
            }}
          />
        ))}
      </MuiTabs>
    </Box>
  );
};

export default SideBarTabs;
